
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslation } from "@/hooks/useTranslation";

export function FilmTableHeader() {
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  return (
    <TableHeader>
      <TableRow className="hover:bg-transparent">
        <TableHead className="font-medium">{t('brand')}</TableHead>
        <TableHead className="font-medium">{isMobile ? t('film') : t('name')}</TableHead>
        {!isMobile && (
          <>
            <TableHead className="font-medium">{t('type')}</TableHead>
            <TableHead className="font-medium">{t('status')}</TableHead>
            <TableHead className="font-medium">ISO</TableHead>
          </>
        )}
        <TableHead className="font-medium">{t('qty')}</TableHead>
        {!isMobile && (
          <TableHead className="font-medium">{t('expiration')}</TableHead>
        )}
        <TableHead className="w-[100px] text-right">{t('actions')}</TableHead>
      </TableRow>
    </TableHeader>
  );
}
